// 👥 Employés E4b — Section 9 : Évaluations (clé RBAC `evaluations`). Gestion réservée au propriétaire, lecture gatée par l'onglet.
import { ClipboardCheck } from 'lucide-react';
import { SectionFiche } from './SectionFiche';
import { EmployeeEvaluationsList } from '@/components/employe/EmployeeEvaluationsList';

export function SectionEvaluations({ employee, peutGerer }) {
  return (
    <SectionFiche cle="evaluations" titre="Évaluations" icone={ClipboardCheck}>
      <EmployeeEvaluationsList employeeId={employee.id} employeeName={`${employee.prenom || ''} ${employee.nom || ''}`.trim()} canManage={peutGerer} />
    </SectionFiche>
  );
}
